// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__199W5","sendOtp":"AuthorizeToLogin_sendOtp__1kOTH"};